import {
  ArchiveIcon,
  HomeIcon,
  type Icon,
  LinkIcon,
  OrganizationIcon,
  RepoForkedIcon,
  RepoIcon,
  RepoLockedIcon,
  RepoTemplateIcon,
} from '@primer/octicons-react'

import {ListSidebar, ListSidebarCollapsedButton} from '../shared/ListSidebar'
import type {TypeFilter} from '../types/repos-list-types'

interface OrgSidebarProps {
  onQueryChanged: (query: string) => void
  type: string
  types: TypeFilter[]
}

const phraseByType: Record<string, string> = {
  all: '',
  public: 'visibility:public archived:false',
  internal: 'visibility:internal archived:false',
  private: 'visibility:private archived:false',
  source: 'mirror:false fork:false archived:false',
  fork: 'fork:true archived:false',
  template: 'template:true archived:false',
  archived: 'archived:true',
}

const iconClassByType: Record<string, Icon> = {
  all: HomeIcon,
  public: RepoIcon,
  internal: OrganizationIcon,
  private: RepoLockedIcon,
  source: LinkIcon,
  fork: RepoForkedIcon,
  template: RepoTemplateIcon,
  archived: ArchiveIcon,
}

export function OrgSidebar({onQueryChanged, type, types}: OrgSidebarProps) {
  return <ListSidebar links={getOrgLinks(types)} selectedLink={type} onQueryChanged={onQueryChanged} />
}

export function OrgSidebarCollapsedButton(props: OrgSidebarProps) {
  return (
    <ListSidebarCollapsedButton
      links={getOrgLinks(props.types)}
      selectedLink={props.type}
      onQueryChanged={props.onQueryChanged}
    />
  )
}

export function getTypeFromQuery(query: string, types: TypeFilter[]) {
  return types.find(({id}) => phraseByType[id] === query.trim())?.id || ''
}

function getOrgLinks(types: TypeFilter[]) {
  return types.map(({id, text}) => ({
    id,
    query: getQueryFromType(id),
    title: text,
    IconComponent: iconClassByType[id] || LinkIcon,
  }))
}

function getQueryFromType(type: string) {
  return phraseByType[type] || ''
}

try{ OrgSidebar.displayName ||= 'OrgSidebar' } catch {}
try{ OrgSidebarCollapsedButton.displayName ||= 'OrgSidebarCollapsedButton' } catch {}